"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { CarFront, ArrowLeft } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LouezVotreVoitureAuMeilleurPrix() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223813" id="events-overview" className="relative bg-secondary overflow-hidden ![margin:23px_0px_23px_0px] ![padding:128px_0px_100px_0px] lg:overflow-visible">
      {}
      <div className="absolute inset-0 pointer-events-none overflow-hidden -z-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary/5 rounded-none blur-3xl -translate-y-1/2"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col items-start text-start transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            
            
            <h1 className="text-4xl md:text-5xl lg:text-[3rem] font-extrabold text-foreground leading-[1.1] mb-6 font-default">
              Join the <span className="text-primary relative inline-block">
                Discourse
                <svg className="absolute w-full h-3 -bottom-1 left-0 text-primary/20" viewBox="0 0 100 10" preserveAspectRatio="none">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="transparent" />
                </svg>
              </span> Series
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl font-default leading-relaxed">
              Participate in our data-driven event series designed to empower citizens and foster responsive governance through rigorous intellectual exchange.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Link to="/events-calendar/" className="w-full sm:w-auto group">
                <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-lg relative overflow-hidden shadow-none rounded-none bg-primary text-primary-foreground transition-all duration-300 hover:bg-primary/90 hover:-translate-y-1">
                  <span className="absolute inset-0 w-full h-full bg-white/10 group-hover:animate-[pulse_1.5s_ease-in-out_infinite] rounded-none opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  <span className="relative flex items-center gap-2">
                    View Calendar
                    <ArrowLeft className="size-5 transition-transform group-hover:translate-x-1 rotate-180" />
                  </span>
                </Button>
              </Link>
              
              <Link to="#" className="w-full sm:w-auto">
                
              </Link>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative mt-12 lg:mt-0 transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            {}
            <div className="absolute inset-0 bg-primary/10 blur-3xl rounded-none -z-10 transform scale-125 lg:scale-150 translate-y-10"></div>
            
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 border border-primary/10 rounded-none -z-10 animate-[spin_30s_linear_infinite]"></div>
            
            {}
            <div className="relative z-10 w-full max-w-lg mx-auto lg:max-w-none lg:scale-125 lg:translate-y-16 lg:-mb-24 origin-center lg:origin-right drop-shadow-none">
              <img src="https://intimate-sawfly-1.10web.cloud/wp-content/uploads/2026/04/IMG_1223.jpg" alt="Featured CAN Event Teaser" className="w-full object-contain grayscale contrast-125 brightness-90 ![padding:0px_0px_1px_0px] !h-[300px]" style={{
              animationName: 'float'
            }} />
            </div>
            
            {}
            <style dangerouslySetInnerHTML={{
            __html: `
              @keyframes float {
                0% { transform: translateY(0px); }
                50% { transform: translateY(-10px); }
                100% { transform: translateY(0px); }
              }
            `
          }} />
          </div>

        </div>
      </div>
    </section>;
}